var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-3"},[_c('Count'),_c('Growth')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }